import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import productBox from '@/components/Blue/ProductBox.vue';
import listingPagination from '@/components/Blue/ProductListing/ListingPagination.vue';
export default defineComponent({
    name: 'products-wrapper',
    components: { productBox, listingPagination },
    computed: Object.assign({}, mapGetters('blue', {
        currentListedProducts: 'currentListedProducts',
    })),
});
